/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIProductionWithdrawalRequest
 */
export interface APIProductionWithdrawalRequest {
    /**
     * 
     * @type {Date}
     * @memberof APIProductionWithdrawalRequest
     */
    timestamp: Date;
    /**
     * 
     * @type {number}
     * @memberof APIProductionWithdrawalRequest
     */
    amount: number;
}

/**
 * Check if a given object implements the APIProductionWithdrawalRequest interface.
 */
export function instanceOfAPIProductionWithdrawalRequest(value: object): value is APIProductionWithdrawalRequest {
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function APIProductionWithdrawalRequestFromJSON(json: any): APIProductionWithdrawalRequest {
    return APIProductionWithdrawalRequestFromJSONTyped(json, false);
}

export function APIProductionWithdrawalRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIProductionWithdrawalRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'timestamp': (new Date(json['timestamp'])),
        'amount': json['amount'],
    };
}

export function APIProductionWithdrawalRequestToJSON(value?: APIProductionWithdrawalRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'timestamp': ((value['timestamp']).toISOString()),
        'amount': value['amount'],
    };
}

